import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { useKeeponButton } from '../../../CrudForm/shared/hooks/useKeeponButton'
import { useCrudFormStore } from '../../../CrudForm/Store/hooks/useStore'
import { useCrudModalFormStore } from '../../Store/hooks/useStore'

import { SubmitButtonProps } from './interface'

export const SubmitButton = ({
  keepon,
  forceShow,
  type = 'primary',
  children: externalChildren,
  ...restProps
}: SubmitButtonProps) => {
  const { toggleModalOpen } = useCrudModalFormStore(state =>
    pick(state, ['toggleModalOpen'])
  )
  const { form, submitLoading, submit } = useCrudFormStore(state =>
    pick(state, ['form', 'submitLoading', 'submit'])
  )

  const { children, ghost, hide } = useKeeponButton({
    keepon,
    forceShow,
    type,
    children: externalChildren
  })

  const handleSubmit = async () => {
    await submit()

    if (keepon) {
      form.reset()
    } else {
      toggleModalOpen()
    }
  }

  return hide ? null : (
    <ActionButton
      ghost={ghost}
      loading={submitLoading}
      type={type}
      onClick={handleSubmit}
      {...restProps}
    >
      {children}
    </ActionButton>
  )
}
